import * as Sentry from '@sentry/browser'

const INITIALIZED_FLAG = '__SENTRY_BROWSER_INITIALIZED__'

function normalizeTraceTarget(target) {
    if (typeof target !== 'string') {
        return null
    }

    const trimmedTarget = target.trim()

    if (!trimmedTarget) {
        return null
    }

    try {
        return new URL(trimmedTarget).origin
    } catch {
        return trimmedTarget
    }
}

function collectTraceTargets(configTargets = []) {
    const targets = [window.location.origin, ...configTargets]
        .map(normalizeTraceTarget)
        .filter(Boolean)

    return [...new Set(targets)]
}

export function initBrowserSentry() {
    if (window[INITIALIZED_FLAG]) {
        return
    }

    const config = window.__SENTRY_CONFIG__

    if (!config?.enabled || !config.dsn) {
        return
    }

    const tracesSampleRate = Number(config.tracesSampleRate)
    const sentryConfig = {
        dsn: config.dsn,
        environment: config.environment || undefined,
        release: config.release || undefined,
        sendDefaultPii: false,
    }

    if (Number.isFinite(tracesSampleRate) && tracesSampleRate > 0) {
        sentryConfig.integrations = [Sentry.browserTracingIntegration()]
        sentryConfig.tracesSampleRate = tracesSampleRate
        sentryConfig.tracePropagationTargets = collectTraceTargets(config.tracePropagationTargets)
    }

    Sentry.init(sentryConfig)
    window[INITIALIZED_FLAG] = true
}
